/*********************
Most Recent Accuracy Rule
*********************/
import Rule from './Rule';
import { ruleInputTypes, ruleTypes } from '../../constants';

export default class MostRecentAccuracyRule extends Rule {
  constructor(logic) {
    super([ruleInputTypes.mostRecentAccuracy],logic);
    this.ruleType = ruleTypes.MOST_RECENT_ACCURACY;
  }
}